import {
  StartNewQuote,
  YourQuote,
  AboutTheTravellers,
  MedicalDeclarationQuestions,
  Signpost,
  QuotePayment, Complete, AggPayment
} from './scenes';
import { IChannel, IStep } from '../../data/api/models';
import { Component } from 'react';
import { get } from 'lodash';

export interface IReactStep extends IStep {
  component: Component;
}

const componentKeyMap = {
  startNewQuote: StartNewQuote,
  yourQuote: YourQuote,
  travellers: AboutTheTravellers,
  medicalHistory: MedicalDeclarationQuestions,
  signpost: Signpost,
  payment: QuotePayment,
  idolPayment: AggPayment,
  cytiPayment: AggPayment,
  complete: Complete,
};

function mapComponentsFromKey(step): IReactStep {
  return {
    ...step,
    component: componentKeyMap[step.key],
  };
}

export default (channel?: IChannel): IReactStep[] => {
  const defaultSteps: IStep[] = [
    {
      title: 'StartNewQuote',
      key: 'startNewQuote',
      route: '/direct',
      calculatePremium: false,
      saveApplication: true,
      saveApplicationWithPatch: false,
      header: 'balloon',
    },
    {
      title: 'Medical',
      key: 'medicalHistory',
      route: '/direct/medical-declaration',
      calculatePremium: false,
      saveApplication: false,
      saveApplicationWithPatch: false,
      header: 'balloon',
    },
    {
      title: 'Signpost',
      key: 'signpost',
      route: '/direct/signpost',
      calculatePremium: false,
      saveApplication: true,
      saveApplicationWithPatch: false,
      header: 'annie'
    },
    {
      title: 'YourQuote',
      key: 'yourQuote',
      route: '/direct/your-quote',
      calculatePremium: false,
      saveApplication: false,
      saveApplicationWithPatch: false,
      header: 'balloon'
    },
    {
      title: 'Payment',
      key: 'payment',
      route: '/direct/payment',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      header: 'annie'
    },
    {
      title: 'Complete',
      key: 'complete',
      route: '/direct/complete',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
    },
  ];

  const config = get(channel, 'steps') ? channel.steps : defaultSteps;

  return config.map(mapComponentsFromKey);
};
